// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"TeamPositionRankings__wrapper--2iFkX","rankingsWrapper":"TeamPositionRankings__rankingsWrapper--2fTFu","collapsed":"TeamPositionRankings__collapsed--38KOk","show-range":"TeamPositionRankings__show-range--2cVaC","showRange":"TeamPositionRankings__show-range--2cVaC"};


//////////////////
// WEBPACK FOOTER
// ./src/app/views/TeamPositionRankings/TeamPositionRankings.css
// module id = Ibx8
// module chunks = 11